module.exports = __webpack_public_path__ + "static/media/piriArtworkBg.596a2be1.JPG";